
(function ($) {
  function show_hide_pagi() {
    if ($('.pagination-button .disabled').length === 2) {
      $('#pagination-container').addClass('hide');
    } else {
      $('#pagination-container').removeClass('hide');
    }
  }

  // Fetch data using json on ready
  var ajax_url = "/wp-content/themes/veritone-voice/json/blog.json";
  var load_data;
  var arr = [];
  var search_Value = '';
  var search_Arr = []; // Arr for by search

  function loadFilter() {
    $.ajax({
      url: ajax_url,
      success: function (data) {
        load_data = data;
        let printItem;
        for (var i = 0; i < data.length; i++) {
          if ($(".blog-grid").hasClass("blog-grid-filter")) {
            printItem = '<div class="item"><a href="' + data[i]["link"] + '" aria-label="Blog"></a><div class="card-wrap"><div class="img-wrap"><img src="' + data[i]["featuredImage"] + '" alt="Thumbnail"></div><div class="card-intro"><span>' + data[i]["date"] + '</span><p>' + data[i]["title"] + '</p></div></div></div>'
          }
          $('.blog-grid .media-container .item-wrap').append(printItem);
        }
      },
    });
  }

  // Set filter on checkbox click 
  function setFilter() {
    $(".blog-grid .media-container .item-wrap").empty();
    let printItem;
    let set_filter_arr;

    var sel_ind_Arr = []; // Arr for by industry
    var sel_solu_Arr = []; // Arr for by solutions
    $(".blog-grid .filter-item").each(function () {
      if ($(this).parent().hasClass('active')) {
        var value = $(this).attr('value');
        var name = $(this).attr('name');
        if (name === 'solutions') {
          sel_solu_Arr.push(value);
          sel_solu_Arr = [...new Set(sel_solu_Arr)]; // Unique Array
        } else if (name === 'industry') {
          sel_ind_Arr.push(value);
          sel_ind_Arr = [...new Set(sel_ind_Arr)]; // Unique Array
        }


        if (search_Arr.length != 0) {
          set_filter_arr = search_Arr;
        } else {
          set_filter_arr = load_data;
        }

        for (var i = 0; i < set_filter_arr.length; i++) {
          if (typeof (set_filter_arr[i][name]) != "undefined") {
            if (set_filter_arr[i][name].length === 1) {
              if (set_filter_arr[i][name][0] === value) {
                arr.push(set_filter_arr[i]["title"]);
              }
            } else {
              for (var j = 0; j < set_filter_arr[i][name].length; j++) {
                if (set_filter_arr[i][name][j] === value) {
                  arr.push(set_filter_arr[i]["title"]);
                }
              }
            }
          }

        }

      }
    });
    // Unique Array
    arr = [...new Set(arr)];
    var store_Arr = [];
    // Get value in array
    for (var k = 0; k < arr.length; k++) {
      const title = arr[k];
      for (var i = 0; i < set_filter_arr.length; i++) {
        if (title === set_filter_arr[i]["title"]) {
          store_Arr.push(set_filter_arr[i]);
        }
      }
    }

    // Check filter value
    arr = [];
    if (sel_ind_Arr.length > 0 && sel_solu_Arr.length > 0) {
      for (var i = 0; i < sel_solu_Arr.length; i++) {
        let solu_value = sel_solu_Arr[i];
        for (var j = 0; j < sel_ind_Arr.length; j++) {
          let indu_value = sel_ind_Arr[j];
          for (var k = 0; k < store_Arr.length; k++) {
            let filter_sol = store_Arr[k]['solutions'];
            let filter_ind = store_Arr[k]['industry'];
            let filter_title = store_Arr[k]['title'];
            for (var l = 0; l < filter_sol.length; l++) {
              var solution_value = filter_sol[l];
              if ((solution_value === solu_value)) {
                for (var m = 0; m < filter_ind.length; m++) {
                  var industry_value = filter_ind[m];
                  if ((industry_value === indu_value)) {
                    arr.push(filter_title);
                    // printItem = '<div class="item"><a href="' + store_Arr[k]["link"] + '"></a><div class="card-wrap"><div class="img-wrap"></div><div class="card-intro"><span>' + store_Arr[k]["date"] + '</span><p>' + store_Arr[k]["title"] + '</p></div></div></div>'
                    // $('.blog-grid .media-container .item-wrap').append(printItem);
                  }
                }
              }
            }
          }
        }
      }
    } else {
      for (var k = 0; k < store_Arr.length; k++) {
        arr.push(store_Arr[k]['title']);
        // printItem = '<div class="item"><a href="' + store_Arr[k]["link"] + '"></a><div class="card-wrap"><div class="img-wrap"></div><div class="card-intro"><span>' + store_Arr[k]["date"] + '</span><p>' + store_Arr[k]["title"] + '</p></div></div></div>'
        // $('.blog-grid .media-container .item-wrap').append(printItem);
      }
    }

    // Unique Array
    arr = [...new Set(arr)];
    for (var i = 0; i < arr.length; i++) {
      for (var j = 0; j < load_data.length; j++) {
        if ((arr[i]) === load_data[j]['title']) {
          printItem = '<div class="item"><a href="' + load_data[j]["link"] + '" aria-label="Blog"></a><div class="card-wrap"><div class="img-wrap"><img src="' + load_data[j]["featuredImage"] + '" alt="Thumbnail"></div><div class="card-intro"><span>' + load_data[j]["date"] + '</span><p>' + load_data[j]["title"] + '</p></div></div></div>'
          $('.blog-grid .media-container .item-wrap').append(printItem);
        }
      }
    }

    // console.log(arr, '==arr');
    // No result check
    if ((search_Arr.length > 0 && arr.length === 0) || (search_Arr.length === 0 && arr.length === 0)) {
      // console.log("No Result Found");
      $(".blog-grid .no-result").addClass('show');
    } else {
      $(".blog-grid .no-result").removeClass('show');
    }
  }

  // Pagination
  function paginate() {
    var items = $(".blog-grid .media-container .item");
    var numItems = items.length;
    var perPage = 8;

    items.slice(perPage).hide();

    $('#pagination-container').pagination({
      items: numItems,
      itemsOnPage: perPage,
      prevText: "&laquo;",
      nextText: "&raquo;",
      onPageClick: function (pageNumber) {
        page_Scroll();
        var showFrom = perPage * (pageNumber - 1);
        var showTo = showFrom + perPage;
        items.hide().slice(showFrom, showTo).show();
      }
    });
  }

  // Checkbox click event
  var flag = 0;
  $(".blog-grid .filter-item").on('click', function () {
    arr = [];
    if ($(this).is(':checked')) {
      $(this).parent().addClass('active');
      setFilter();

    } else {
      $(this).parent().removeClass('active');
      var len = $('.blog-grid .list .active').length;
      if (search_Value === '' && len > 0) {
        setFilter();
      } else if (search_Value != '' && len === 0) {
        search();
      } else if (search_Value != '' && len > 0) {
        $(".blog-grid .media-container .item-wrap").empty();
        setFilter();
        search();
      } else if (search_Value == '' && len === 0) {
        $(".blog-grid .media-container .item-wrap").empty();
        loadFilter();
      }

    }

    setTimeout(function () {
      paginate();
      show_hide_pagi();
    }, 500);

    if (flag === 0) {
      // page_Scroll();
      flag = 1;
      setTimeout(function () {
        flag = 0;
      }, 500);
    }
  })


  // Search Functionality
  function search() {
    if (search_Value === '') {
      if (arr.length === 0) {
        $(".blog-grid .media-container .item-wrap").empty();
        loadFilter();
      } else {
        setFilter();
      }

    } else {
      $(".blog-grid .media-container .item-wrap").empty();
      let print_Arr;
      if (arr.length > 0) {
        // Clone Array
        print_Arr = [...arr];
      } else {
        // Clone Array
        print_Arr = [...load_data];
      }

      let printItem;
      if (arr.length > 0) {
        print_Arr = print_Arr.filter(function (i) {
          return (i.toLowerCase().match(search_Value.toLowerCase()))
        });
      } else {
        print_Arr = print_Arr.filter(function (i) {
          return (i.title.toLowerCase().match(search_Value.toLowerCase()))
        });

        search_Arr = [];
        search_Arr = [...print_Arr];
      }

      if (print_Arr.length > 0) {
        $(".blog-grid .no-result").removeClass('show');
        for (var k = 0; k < print_Arr.length; k++) {
          let title = '';
          if (arr.length > 0) {
            title = print_Arr[k];
          } else {
            title = print_Arr[k]['title'];
          }

          for (var i = 0; i < load_data.length; i++) {
            if (title === load_data[i]["title"]) {
              printItem = '<div class="item"><a href="' + load_data[i]["link"] + '" aria-label="Blog"></a><div class="card-wrap"><div class="img-wrap"><img src="' + load_data[i]["featuredImage"] + '" alt="Thumbnail"></div><div class="card-intro"><span>' + load_data[i]["date"] + '</span><p>' + load_data[i]["title"] + '</p></div></div></div>'
              $('.blog-grid .media-container .item-wrap').append(printItem);
            }
          }
        }
        // console.log("Show Result");
        $(".blog-grid .no-result").removeClass('show');
      } else {
        // No Result Code
        // console.log("No Result Found");
        $(".blog-grid .no-result").addClass('show');
      }
    }

    setTimeout(function () {
      paginate();
      show_hide_pagi();
    }, 500);
    // page_Scroll();
  }

  $(document).on('click', '.blog-grid .search-btn', function () {
    search_Value = $('.blog-grid .search').val();
    search();
    no_result();
    show_Hide_Latest_Post();
  });

  $('.blog-grid .search').keydown(function (e) {
    if (e.keyCode == 13) {
      search_Value = $('.blog-grid .search').val();
      search();
      no_result();
      show_Hide_Latest_Post();
    }
  });

  $(document).ready(function () {
    loadFilter();
    setTimeout(function () {
      paginate();
      show_hide_pagi();
    }, 500);

    selected_Filter();
    rm_selected_Filter();
  });


  // All checked functionality
  $(".blog-grid ul .all").on('click', function () {
    $(this).parent().find('li').each(function () {
      if (!$(this).hasClass('active')) {
        $(this).find('.filter-item').trigger('click');
      }
    })
  })

  // Update Selected Filter functionality
  function selected_Filter() {
    $(".blog-grid ul .filter-item").on('click', function () {
      var value = $(this).attr('value');
      if ($(this).parent().hasClass('active')) {
        var text = $(this).parent().find('label').text();
        $('.blog-grid .field-wrap').append('<span value=' + value + '>' + text + '</span>');

      } else if (!$(this).parent().hasClass('active')) {
        $('.blog-grid .field-wrap span').each(function () {
          var value2 = $(this).attr('value');
          if (value2 === value) {
            $(this).remove();
          }
        });
      }

      selected_Filter_Show_Hide();
      show_Hide_Latest_Post();
    })
  }

  // Selected Filter Show Hide 
  function selected_Filter_Show_Hide() {
    var len = $('.blog-grid .filter-element-wrap span').length;
    if (len > 0) {
      $('.blog-grid .filter-element-wrap').removeClass('hide');
    } else if (len === 0) {
      $('.blog-grid .filter-element-wrap').addClass('hide');
    }
  }

  // Latest Post Show Hide 
  function show_Hide_Latest_Post() {
    var len = $('.blog-grid .filter-element-wrap span').length;
    // console.log(len, '==len');
    if (len > 0 || search_Value) {
      $('.blog-grid .full-card').addClass('hide');
      $('.blog-grid .outer-wrap h3').addClass('hide');
    } else if (len === 0 || search_Value == '') {
      $('.blog-grid .full-card').removeClass('hide');
      $('.blog-grid .outer-wrap h3').removeClass('hide');
    }
  }

  // Remove Selected Filter functionality
  function rm_selected_Filter() {
    $(document).on('click', ".blog-grid .field-wrap span", function () {
      var value = $(this).attr('value');
      $(".blog-grid ul .filter-item").each(function () {
        var value2 = $(this).attr('value');
        if (value2 === value) {
          $(this).trigger('click');
        }
      })

      no_result();
    })
  }

  function no_result() {
    setTimeout(function () {
      var len = $('.blog-grid .item-wrap .item').length;
      if (len > 0) {
        $('.blog-grid .no-result').removeClass('show');
      }
    }, 500)
  }

  function page_Scroll() {
    $("html, body").delay(500).animate({
      scrollTop: $(".blog-grid .column-wrapper").offset().top - 130,
    }, 500);
  }

  // URL based functionality
  if ($('.blog-grid').length > 0) {
    // Code for update value in address bar START
    function removeUrl() {
      var href = window.location.origin + window.location.pathname;
      history.pushState({}, null, href);
    }

    // Update URL
    function urlUpdate(str) {
      var href = window.location.href;
      var href1 = href.split("?");
      var newitem = href1[0].toString();
      href1.shift();
      var newhref = href1.join(" ");
      newhref = newhref.split("$");

      if (href.includes(str)) {
        for (var i = 0; i < newhref.length; i++) {
          if (newhref[i].toString().includes(str)) {
            newhref.splice(i, 1)
            newhref.push(str)
          }
        }
        newhref = newhref.join('$')
        href1 = newitem + '?' + newhref;
        history.pushState({}, null, href1);
      }
      else {
        if (href1.length < 1) {
          history.pushState({}, null, href + '?' + str);
        } else {
          history.pushState({}, null, href + '$' + str);
        }
      }
    }

    // Fetch URL
    function fetchUrl() {
      var href = window.location.href, array = [];
      href = href.split('?');
      href.shift();
      var newhref = href.join(" ");
      newhref = newhref.split("$");
      for (var i = 0; i < newhref.length; i++) {
        array.push(newhref[i].toString().split('='));
      }

      for (var i = 0; i < array.length; i++) {
        var item = array[i];

        if (item[0] === "search") {
          var numbersArray = item[1].split(',');
          for (var j = 0; j < numbersArray.length; j++) {
            var itemVal;
            itemVal = numbersArray[j];
            var str = '#page';
            if (itemVal.indexOf(str) != -1) {

            } else {
              var str = itemVal.split('%20').join(' ');
              $('.blog-grid .input-wrapper input').val(str);
              $('.blog-grid-filter .outer-wrap .input-wrapper .search-btn').trigger('click');
            }
          }
        }

        if (item[0] === "solutions") {
          var numbersArray = item[1].split(',');
          for (var j = 0; j < numbersArray.length; j++) {
            var itemVal, selectedTxt;
            itemVal = numbersArray[j];
            $('.blog-grid #solutions li').each(function () {
              var selectedItemVal;
              var itemClass = $(this).attr("class");
              selectedItemVal = $(this).find('.filter-item').attr("value");
              if (itemClass != "active") {
                if (itemVal === selectedItemVal) {
                  $(this).addClass("active");
                  $(this).find('.filter-item').trigger('click');
                }
              }
            });
          }
        }

        if (item[0] === "industry") {
          var numbersArray = item[1].split(',');
          for (var j = 0; j < numbersArray.length; j++) {
            var itemVal, selectedTxt;
            itemVal = numbersArray[j];
            $('.blog-grid #industry li').each(function () {
              var selectedItemVal;
              var itemClass = $(this).attr("class");
              selectedItemVal = $(this).find('.filter-item').attr("value");
              if (itemClass != "active") {
                if (itemVal === selectedItemVal) {
                  $(this).addClass("active");
                  $(this).find('.filter-item').trigger('click');
                }
              }
            });
          }
        }

      }

    }

    // Push value in array
    function listValue() {
      var sol_arr = [], ind_arr = [], search_arr = [];
      $('.blog-grid #solutions').find('li.active').each(function () {
        var listVal = $(this).find('.filter-item').attr("value");
        sol_arr.push(listVal);
      });

      $('.blog-grid #industry').find('li.active').each(function () {
        var listVal = $(this).find('.filter-item').attr("value");
        ind_arr.push(listVal);
      });

      $('.blog-grid .outer-wrap .input-wrapper').find('input').each(function () {
        var listVal = $(this).val();
        search_arr.push(listVal);
      });

      urlUpdate("solutions=" + sol_arr + "$industry=" + ind_arr + "$search=" + search_arr + "");
    }


    $(".blog-grid ul .filter-item").on('click', function () {
      removeUrl();
      listValue();
    })

    $(document).on('click', '.blog-grid .search-btn', function () {
      removeUrl();
      listValue();
    });

    $('.blog-grid .search').keydown(function (e) {
      if (e.keyCode == 13) {
        removeUrl();
        listValue();
      }
    });

    // Clear All Envent
    $(document).on('click', '.blog-grid .clear-all', function () {
      $('.blog-grid .input-wrapper input').val('');
      $('.blog-grid .search-btn').trigger('click');
      setTimeout(function () {
        search_Arr = [];
        removeUrl();
        $('.blog-grid .field-wrap span').trigger('click');
        // loadFilter();
        // paginate();
      }, 500);
    });

    $(window).on('load', function () {
      setTimeout(function () {
        fetchUrl();
        selected_Filter_Show_Hide();
        show_Hide_Latest_Post();
      }, 500);
    });
  }

})(jQuery);
